var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"variant"},[_c('img',{staticClass:"lazyload",attrs:{"data-src":_vm.thumbnailImageUrl,"data-index":_vm.tabToOpen,"alt":_vm.variantname},on:{"click":_vm.openTab}}),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }